var path = '/static/assets/khapps/quakeroats/weather/qoip-weather.component.html';
var html = "<md-content layout=\"row\" style=\"overflow: hidden;\">\n    <div id=\"chart_container\" flex></div>\n</md-content>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;